import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../service/api";
import { CustomModal } from "../../../components/CustomModal";
import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { LoadingSpinner } from "../../../components/LoadingSpinner";
import { TextInput } from "../../../components/core/inputs/TextInput";

export interface AddLocationModalProps {
    open: boolean;
    groupId: number;
    onConfirm: (id: number) => void;
    onClose: () => void;
}
export const AddLocationModal = ({open, groupId, onConfirm, onClose}: AddLocationModalProps) => {
    const [selectedId, setSelectedId] = useState<number|null>(null);
    const [locations, setLocations] = useState<any[]|null>(null);
    const [search, setSearch] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        if (!open) return;
        setSelectedId(null);
        setLocations(null);
        setSearch('');

        API.GET(`/api/admgroups/${groupId}/notl`)
            .then(l => setLocations(l))
            .catch(err => alert(err.message));
    }, [open]);

    return (
        <CustomModal
            open={open}
            title={t('add_location_to_group')}
            onClose={onClose}
            footer={<>
                <MDBBtn color="secondary" onClick={onClose}>{t('cancel')}</MDBBtn>
                <MDBBtn color="primary" disabled={!selectedId} onClick={() => onConfirm(selectedId ?? -1)}>{t('confirm')}</MDBBtn>
            </>}
        >
                {locations == null && <LoadingSpinner/>}
                {locations !== null && (
                    <div className="d-flex flex-column">
                        <TextInput label={t('search')} value={search} onValueChange={setSearch}/>
                        <div className="d-flex flex-column overflow-auto px-1 pt-2 pb-2" style={{maxHeight: 500, minWidth: 300, userSelect: 'none'}}>
                            {locations.map(l => (
                                <div key={l.id} className="flex-row align-items-center hover-shadow p-1" style={{cursor: 'pointer', background: l.id == selectedId ? '#0000001a' :'', display: l.Name.toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) == '-1' ? 'none': 'flex'}} onClick={() => setSelectedId(l.id)}>
                                    <MDBIcon icon="map-marker-alt" color="primary"/>
                                    <span className="ms-1">{l.Name} (<MDBIcon icon="server" size="xs" color="primary"/>{l.nrOfMachines})</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                )}
        </CustomModal>
    )
}